import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('placementUser');
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (err) {
        console.error('Failed to parse user session', err);
        localStorage.removeItem('placementUser');
      }
    }
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    setUser(userData);
    localStorage.setItem('placementUser', JSON.stringify(userData));
    localStorage.setItem('placementToken', token);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('placementUser');
    localStorage.removeItem('placementToken');
    // Clear other data if needed
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, isLoading: loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
